import { IconButton, useTheme } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';

export const DeleteButton = (props: any) => {
    const {
        variant = 'permanent',
        onClick,
        disabled,
        readOnly,
        ariaLabel,
        removeButtonSx,
        borderLess,
        backgroundLess,
        ...rest
    } = props
    const theme = useTheme();
    const color = theme.palette;

    return <IconButton
        {...rest}
        onClick={onClick}
        disabled={disabled || readOnly}
        aria-label={ariaLabel}
        sx={{
            width: 40,
            height: 40,
            border: !!borderLess ? 'none' : `1px solid ${color.inputNew.removeBorder}`,
            borderRadius: '4px',
            color: color.inputNew.removeIcon,
            '&:hover': {
                backgroundColor: 'rgba(255, 107, 107, 0.08)',
                borderColor: color.inputNew.removeBorder,
            },
            '&.Mui-disabled': {
                borderColor: color.inputNew.inputBorder,
                backgroundColor: color.inputNew.inputBorder,
            },
            ...(!backgroundLess && {
                backgroundColor: 'transparent',
            }),
            ...removeButtonSx,
        }}
    >
        {variant === 'temporary' && <CloseIcon sx={{ color: color.inputNew.removeIcon }} />}
        {variant === 'permanent' && <DeleteIcon sx={{ color: color.inputNew.removeIcon }} />}
        {variant === 'permanent-secondary' && <DeleteIcon sx={{ color: "white" }} />}
    </IconButton>
}


export const DeleteButtonSecondary = (props: any) => {
    const {
        variant = 'permanent',
        onClick,
        disabled,
        readOnly,
        ariaLabel,
        removeButtonSx,
        borderLess,
        backgroundLess,
        ...rest
    } = props
    const theme = useTheme();
    const color = theme.palette;

    return <IconButton
        {...rest}
        onClick={onClick}
        disabled={disabled || readOnly}
        aria-label={ariaLabel}
        sx={{
            width: 40,
            height: 40,
            border: !!borderLess ? 'none' : `1px solid ${color.inputNew.removeBorder}`,
            borderRadius: '4px',
            color: "#FFFFFF",
            backgroundColor: "#FF0000CC",
            '&:hover': {
                backgroundColor: "#FF0000",
                borderColor: color.inputNew.removeBorder,
            },
            '&.Mui-disabled': {
                borderColor: color.inputNew.inputBorder,
                backgroundColor: color.inputNew.inputBorder,
            },
            ...(!!backgroundLess && {
                backgroundColor: 'transparent',
            }),
            ...(disabled && {
                opacity: '0.6',
            }),
            ...removeButtonSx,
        }}
    >
        {variant === 'temporary' && <CloseIcon sx={{ color: "#FFFFFF" }} />}
        {variant === 'permanent' && <DeleteIcon sx={{ color: "#FFFFFF" }} />}
    </IconButton>
}